export const VIDEO_FORMATS = ['.mp4', '.avi', '.mov', '.mkv']

export const isVideo = (url: string): boolean => VIDEO_FORMATS.some(format => url?.endsWith(format))
